import { formatDate } from '@angular/common';
import { Component, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, map, Observable, Subject, switchMap } from 'rxjs';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { ApiSalesService } from 'src/app/services/api-sales.service';
import { EventosService } from 'src/app/services/eventos.service';
import { OrdersEventService } from 'src/app/services/orders-event.service';
import { PlacesService } from 'src/app/services/places.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-orders-list',
  templateUrl: './orders-list.component.html',
  styleUrls: ['./orders-list.component.scss']
})
export class OrdersListComponent implements OnInit {
    statusList: any[] = [];
  methodsList: any[] = [];

  searchText!: any;
  business!: any;
  places: any[] = [];
  placesEnabled: any[] = [];
  placeFilter: any = null;
  @Input() idEvent!: any;

  // Select Items
  activeSelectList: boolean = false;
  selectedItems: any[] = [];

  statusOptions: Observable<any> = new Observable<any>();
  methodsOptions: Observable<any> = new Observable<any>();
  maxPriceEnabled: number = 500;

  // Calendar
  datesRange!: any;
  stringDate: string = '';
  openDatePicker: boolean = false;

  // Filter Options
  activeFilters: boolean = false;
  showMobileFilters: boolean = false;
  dateFilter!: any;
  selectedPriceRange!: any;
  priceFilter: any = { min: 0, max: 500 };
  statusFilter!: any;
  openPriceRange: boolean = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  filterActive: boolean = false;
  methodFilter!: any;
  changeMethod: boolean = false;
  changeStatus: boolean = false;

  activeSearchItems: boolean = false;
  private searchTerms = new Subject<string>();

  loadingFilter: boolean = false;
  schedulesEvent: Observable<any> = new Observable<any>();
  scheduleSelected!: any;
  changedSchedule: boolean = false;

  // Sesiones
  sessions: any[] = [];
  filteredSessions: any[] = [];
  selectedSession: any[] = [];
  changedSession: boolean = false;

  constructor(private orderService: OrdersEventService, private apiSalesService: ApiSalesService,private eventServices: EventosService,
    public formatter: NgbDateParserFormatter, private reportService: ReportsService, private dialog: MatDialog,
    private placeService: PlacesService) { }

  ngOnInit(): void {
    this.business = JSON.parse(localStorage.getItem('business') || '{}');
    this.places = JSON.parse(localStorage.getItem('places') || '[]');

    // Restaurar filtros guardados (al volver desde el detalle de un pedido)
    const storedState = this.orderService.getFiltersState();
    if (storedState) {
      this.searchText = storedState.searchOrder;
      const f = storedState.filterOrders;
      if (f) {
        // placeFilter se aplica después de cargar los espacios para que mat-select lo muestre correctamente
        this.dateFilter = f.dateFilter ?? null;
        this.stringDate = f.dateFilter
          ? (f.dateFilter.date_from || '') + (f.dateFilter.date_to ? ' - ' + f.dateFilter.date_to : '')
          : '';
        if (f.priceFilter) {
          this.priceFilter = f.priceFilter;
          if (f.priceFilter.min > 0 || f.priceFilter.max < this.maxPriceEnabled) {
            this.selectedPriceRange = f.priceFilter.min + '€ - ' + f.priceFilter.max + '€';
          }
        }
        this.statusFilter = f.statusFilter ?? null;
        this.methodFilter = f.methodFilter ?? null;
        this.selectedSession = f.sessions ?? [];
        const hasFilter = !!(f.placeFilter || this.dateFilter || this.statusFilter || this.methodFilter ||
          (f.priceFilter && (f.priceFilter.min > 0 || f.priceFilter.max < this.maxPriceEnabled)) ||
          (this.selectedSession && this.selectedSession.length > 0));
        if (hasFilter) {
          this.activeFilters = true;
          this.filterActive = true;
        }
      }
    }

    if (this.business?.id) {
      this.placeService.getListFilterPlaces(this.business.id, 1, null, null, true).subscribe({
        next: (res) => {
          const allPlaces = Array.isArray(res) ? res : res?.data?.data || res?.data || [];
          this.placesEnabled = this.placeService.filterManagedPlaces(allPlaces, this.business?.id);
          // Restaurar placeFilter aquí para que mat-select encuentre las opciones ya renderizadas
          const stored = this.orderService.getFiltersState();
          if (stored?.filterOrders?.placeFilter) {
            this.placeFilter = stored.filterOrders.placeFilter;
          }
        }
      });
    }

    this.orderService.setLoadingTable(true);
    this.statusOptions = this.apiSalesService.getStatusByBusiness().pipe(map(res => res.data));
    this.methodsOptions = this.apiSalesService.getAllMethods().pipe(map(res => res.data));
    // Suscribirse una sola vez y guardar los métodos
    this.methodsOptions.subscribe({
      next: (methods) => {
        this.methodsList = methods;
      },
      error: (err) => {
        console.error('Error cargando métodos:', err);
        this.methodsList = [];
      }
    });
    // Suscribirse una sola vez y guardar los estados
    this.statusOptions.subscribe({
      next: (statuses) => {
        this.statusList = statuses;
      },
      error: (err) => {
        console.error('Error cargando estados:', err);
        this.statusList = [];
      }
    });
    if (this.idEvent) {
      // Cambiar API
      this.schedulesEvent = this.eventServices.getEventById(this.idEvent).pipe(map(res => {res.data.sessions.sort((a: any, b: any) => (new Date(a.start_date).getTime() - new Date(b.start_date).getTime())); return res.data.sessions;}));

      // Cargar sesiones para el filtro
      this.eventServices.getEventById(this.idEvent).subscribe({
        next: (res) => {
          if (res.success && res.data && res.data.sessions) {
            this.sessions = res.data.sessions.sort((a: any, b: any) =>
              new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
            );
            this.filteredSessions = [...this.sessions];
          }
        },
        error: (err) => {
          console.error('Error cargando sesiones:', err);
          this.sessions = [];
          this.filteredSessions = [];
        }
      });
    }

    this.apiSalesService.getMaxPriceByCompany(this.business?.id).subscribe({
      next: (res) => {
        this.priceFilter.max = res?.data;
        this.maxPriceEnabled = res?.data;
      }
    });
    this.searchTerms.pipe(
      debounceTime(500), // Espera 300ms después de cada pulsación de tecla
      distinctUntilChanged(), // Ignora si el nuevo término de búsqueda es igual al anterior
    ).subscribe(items => {
      this.activeSearchItems = false;
      this.orderService.setSearchOrder(items);
    });

    this.orderService.filtersOrderStorage.subscribe({
      next: (res) => {
        if (res) {
          this.searchText = res?.searchOrder;
        }
      }
    });

    this.orderService.loadingTableStorage.subscribe({
      next: (res) => {
        this.loadingFilter = res;
      }
    })
  }

  searchOrder(event) {
    this.searchText = event;
    this.searchTerms.next(this.searchText);
    // this.orderService.setSearchOrder(this.searchText);
  }

  openFilters() {
    // En desktop, toggle activeFilters
    // En mobile, si hay filtros activos, solo toggle el offcanvas
    if (window.innerWidth <= 992) {
      // Móvil
      if (this.activeFilters) {
        // Si ya hay filtros activos, solo toggle el offcanvas
        this.showMobileFilters = !this.showMobileFilters;
      } else {
        // Si no hay filtros, activar y mostrar offcanvas
        this.activeFilters = true;
        this.showMobileFilters = true;
      }
    } else {
      // Desktop
      this.activeFilters = !this.activeFilters;
      if (!this.activeFilters && this.filterActive) {
        this.dateFilter = null;
        this.priceFilter = null;
        this.statusFilter = null;
        this.methodFilter = null;
        this.clearFilters();
      }
    }
  }

  closeMobileFilters() {
    this.showMobileFilters = false;
  }

  updateMethod() {
    if (this.changeMethod) {
      this.updateFilter();
      this.changeMethod = false;
    }
  }

  changePlaceFilter() {
    this.filterActive = !!this.placeFilter;
    this.orderService.setLoadingTable(true);
    this.orderService.setFilters(this.dateFilter, this.priceFilter, this.statusFilter, this.methodFilter, this.selectedSession, this.placeFilter);
  }

  updateStatus() {
    if (this.changeStatus) {
      this.updateFilter();
      this.changeStatus = false;
    }
  }

  updateSchedule() {
    if (this.changedSchedule) {
      this.updateFilter();
      this.changedSchedule = false;
    }
  }

  updateSessionFilter() {
    if (this.changedSession) {
      this.updateFilter();
      this.changedSession = false;
    }
  }

  activeSelecting() {
    this.activeSelectList = !this.activeSelectList;
    // Eliminar la seleccion actual
  }

  containsBlocked() {
    return this.selectedItems.filter((item) => item.sales_channel?.name != 'Web').length <= 0;
  }

  selectedItemsChange(event: any) {
    this.selectedItems = event;
  }

  openInfoCard(msg: string, disabledClose: boolean = false, icon: boolean = true) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        icon: icon,
        text: msg,
        btnCancel: false
      }
    });
  }

  returnAll() {

  }

  updateFilter(active: boolean = true) {
    this.filterActive = active;
    this.orderService.setLoadingTable(true);
    // Usar selectedSession si está definido, sino usar scheduleSelected para compatibilidad
    const sessionFilter = this.selectedSession && this.selectedSession.length > 0 ? this.selectedSession : this.scheduleSelected;
    this.orderService.setFilters(this.dateFilter, this.priceFilter, this.statusFilter, this.methodFilter, sessionFilter, this.placeFilter);
  }


  changeValuesPrice() {
    this.selectedPriceRange = this.priceFilter.min + '€ - ' + this.priceFilter.max + '€';
    this.filterActive = true;
    this.updateFilter();
  }

  selectDates(datesRange: any) {
    this.datesRange = datesRange;
    let stringDates = this.formatStringDate(datesRange.min);
    if (datesRange.max) {
      stringDates += ' - ' + this.formatStringDate(datesRange.max);
    }
    this.stringDate = stringDates;
    this.dateFilter = { date_from: this.formatStringDate(datesRange.min, 'yyyy-MM-dd'), date_to: this.formatStringDate(datesRange.max, 'yyyy-MM-dd') };
    this.filterActive = true;
    this.updateFilter();
  }

  formatStringDate(date: any, format: string = 'dd MMM yy') {
    let dateFormat = null;
    if (date) {
      dateFormat = formatDate(new Date(date), format, 'es', '+0000');
    }
    return dateFormat;
  }

  clearFilters() {
    this.dateFilter = null;
    this.priceFilter = { min: 0, max: this.maxPriceEnabled };
    this.statusFilter = null;
    this.methodFilter = null;
    this.placeFilter = null;
    this.scheduleSelected = null;
    this.selectedSession = [];
    this.selectedPriceRange = null;
    this.stringDate = '';
    this.openPriceRange = false;
    this.filterActive = false;
    this.activeFilters = false;
    this.updateFilter(false);
  }

  deleteFilter(filter: any) {
    if (filter === this.searchText) {
      this.searchText = null;
      this.orderService.setSearchOrder(null);
    } else if (filter === this.dateFilter) {
      this.dateFilter = null;
      this.stringDate = '';
    } else if (filter === this.priceFilter) {
      this.priceFilter = { min: 0, max: this.maxPriceEnabled };
      this.selectedPriceRange = null;
    } else if (filter === this.statusFilter) {
      this.statusFilter = null;
    } else if (filter === this.methodFilter) {
      this.methodFilter = null;
    } else if (filter === this.scheduleSelected) {
      this.scheduleSelected = null;
    } else if (this.selectedSession.includes(filter)) {
      this.selectedSession = this.selectedSession.filter(session => session !== filter);
    }
    this.updateFilter(this.dateFilter || (this.priceFilter.min > 0 || this.priceFilter.max < this.maxPriceEnabled) || this.statusFilter || this.methodFilter || this.scheduleSelected || (this.selectedSession && this.selectedSession.length > 0));
  }

  getFiltersActive(){
    let filters = [];
    if(this.dateFilter){
      this.dateFilter.name = this.dateFilter.date_from + " - " + this.dateFilter.date_to;
      filters.push(this.dateFilter);
    }
    if(this.priceFilter && (this.priceFilter.min > 0 || this.priceFilter.max < this.maxPriceEnabled)){
      this.priceFilter.name = "precio";
      this.priceFilter.type = "price";
      filters.push(this.priceFilter);
    }
    if(this.statusFilter){
      // Buscar el nombre correspondiente al id en statusList
      let statusName = '';
      if (this.statusFilter && this.statusList && this.statusList.length > 0) {
        // statusFilter puede ser un id o un objeto con id
        const statusId = typeof this.statusFilter === 'object' && this.statusFilter.id ? this.statusFilter.id : this.statusFilter[0] || this.statusFilter;
        const found = this.statusList.find((s: any) => s.id == statusId);
        statusName = found ? found.name : statusId;
      }
      this.statusFilter.name = statusName;
      filters.push(this.statusFilter);
    }
    if(this.methodFilter){
      // Buscar el nombre correspondiente al id en methodsList
      let methodName = '';
      if (this.methodFilter && this.methodsList && this.methodsList.length > 0) {
        // methodFilter puede ser un id o un objeto con id
        const methodId = typeof this.methodFilter === 'object' && this.methodFilter.id ? this.methodFilter.id : this.methodFilter[0] || this.methodFilter;
        const found = this.methodsList.find((m: any) => m.id == methodId);
        methodName = found ? found.name : methodId;
      }
      this.methodFilter.name = methodName;
      filters.push(this.methodFilter);
    }
    /*if(this.scheduleSelected){
      this.scheduleSelected.name = "sesion";
      filters.push(this.scheduleSelected);
    }
    if(this.selectedSession && this.selectedSession.length > 0){
      this.selectedSession.forEach(session => {
        filters.push(session);
      });
    }*/
    return filters;
  }

}
